export default "__VITE_ASSET__DLicpSGV__"